import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

export default function NoAccess() {
    return (
        <div>
            <Container maxWidth="lg">
                <Grid justify="center" container>
                    <Grid
                        xs={12}
                        item
                        className="thmp-container-not-authorized"
                    >
                        Not Authorized
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
